<div class="modal-header">
  <h4 class="modal-title">{{ pageTitle }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <h4 class="product my-2">
    <b>[{{ rfq.internal_sku }}]</b> {{ rfq.product_name }}
  </h4>
  <button class="btn btn-secondary btn-sm" type="button" (click)="addPipeline()">
    <i class="fas fa-plus"></i> Add Pipeline
  </button>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>Pipeline</th>
        <th>Stage</th>
        <th>Priority</th>
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rp of rfqPipelines; let i = index">
        <td>
          <select
            class="form-control"
            name="{{ 'pipeline' + i.toString() }}"
            [(ngModel)]="rp.pipeline_id"
            (change)="setStages(i)"
          >
            <option *ngFor="let p of pipelines" [value]="p.id">{{
              p.label
            }}</option>
          </select>
        </td>
        <td>
          <select
            class="form-control"
            name="{{ 'stage' + i.toString() }}"
            [(ngModel)]="rp.stage_id"
          >
            <option *ngFor="let s of rp.stages" [value]="s.id">{{
              s.stage
            }}</option>
          </select>
        </td>
        <td>
          <select
            class="form-control"
            name="{{ 'priority' + i.toString() }}"
            [(ngModel)]="rp.priority"
          >
            <option *ngFor="let s of pipelineSvc.priorities" [value]="s.id">{{
              s.label
            }}</option>
          </select>
        </td>
        <td valign="middle">
          <a href="javascript:;" (click)="rfqPipelines.splice(i, 1)">
            <i class="fas fa-times text-danger"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="activeModal.dismiss('')"
    [translate]="'BUTTONS.CLOSE'"
  >
    <i class="fas fa-times"></i> Close</button
  >
  <button
    type="button"
    class="btn btn-primary"
    [ngClass]="{
      'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
    }"
    [disabled]="loading"
    (click)="saveRfqPipelines()"
  >
    <i class="fas fa-save"></i> Set SKU Pipelines
  </button>
</div>
